const PLACEHOLDER_REGEX = /\[[^\]]+\]/g;

export function detectPlaceholders(data) {
  const results = [];
  const scan = (text, path) => {
    if (!text || typeof text !== "string") return;
    const matches = text.match(PLACEHOLDER_REGEX);
    if (matches) matches.forEach(m => results.push({ path, text, placeholder: m }));
  };
  if (!data) return results;
  Object.keys(data.contact || {}).forEach(k => scan(data.contact[k], `contact.${k}`));
  scan(data.summary, "summary");
  (data.experience || []).forEach((exp, i) => {
    ["title", "company", "location", "start_date", "end_date"].forEach(f => scan(exp[f], `experience.${i}.${f}`));
    (exp.bullets || []).forEach((b, j) => scan(b, `experience.${i}.bullets.${j}`));
  });
  (data.education || []).forEach((edu, i) => {
    ["degree", "institution", "graduation_date", "location"].forEach(f => scan(edu[f], `education.${i}.${f}`));
    (edu.details || []).forEach((d, j) => scan(d, `education.${i}.details.${j}`));
  });
  (data.skills || []).forEach((sk, i) => {
    scan(sk.name, `skills.${i}.name`);
    (sk.items || []).forEach((item, j) => scan(item, `skills.${i}.items.${j}`));
  });
  (data.certifications || []).forEach((cert, i) => {
    ["name", "issuer", "date"].forEach(f => scan(cert[f], `certifications.${i}.${f}`));
  });
  return results;
}

export function getAtPath(obj, pathStr) {
  const keys = pathStr.split(".");
  let cur = obj;
  for (const k of keys) {
    if (cur == null) return undefined;
    cur = cur[isNaN(Number(k)) ? k : Number(k)];
  }
  return cur;
}

export function setAtPath(obj, pathStr, value) {
  const keys = pathStr.split(".");
  let cur = obj;
  for (let i = 0; i < keys.length - 1; i++) {
    const k = isNaN(Number(keys[i])) ? keys[i] : Number(keys[i]);
    if (cur == null || cur[k] == null) return;
    cur = cur[k];
  }
  const last = keys[keys.length - 1];
  cur[isNaN(Number(last)) ? last : Number(last)] = value;
}
